import styled from "styled-components";

export const AppInstallContainer = styled.div`
  overflow: hidden;
  width: 100vw;
  height: calc(100vh - 500px);
  margin: 100px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  button {
    width: 300px;
    height: 100px;
    font-size: 30px;
    border: none;
    background: #0074ca;
    color: #fff;
    border-radius: 30px;
  }
`;

export const StampPage = styled.div`
  min-height: 100vh;
  max-width: 1440px;
  margin: auto;
  width: 100%;
  padding: 20px;
  user-select: none;
  img {
    max-width: 100%;
    height: 100%;
  }
  .logo {
    width: auto;
    font-size: 22px;
    font-weight: 700;
    margin: 0 0 20px;
    cursor: pointer;
  }
  @media screen and (max-width: 1050px) {
  }
  @media screen and (max-width: 767px) {
  }
`;
